// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3_oS-","header":"PatientBlock_header__25fcf","label":"PatientBlock_label__2tEK_","option":"PatientBlock_option__1gqiC"};